import { render } from "./OuterTopPage.vue?vue&type=template&id=9aab3d98&scoped=true&ts=true"
import script from "./OuterTopPage.vue?vue&type=script&lang=ts"
export * from "./OuterTopPage.vue?vue&type=script&lang=ts"

import "./OuterTopPage.vue?vue&type=style&index=0&id=9aab3d98&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aab3d98"]])

export default __exports__